import { render, staticRenderFns } from "./alarmCall.vue?vue&type=template&id=74f999f8&scoped=true&"
import script from "./alarmCall.vue?vue&type=script&lang=js&"
export * from "./alarmCall.vue?vue&type=script&lang=js&"
import style0 from "./alarmCall.vue?vue&type=style&index=0&id=74f999f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f999f8",
  null
  
)

export default component.exports